import React from 'react';
import logo from '../assets/final-krz-logo.webp';

export const KrzzLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: "h-10",
    default: "h-12",
    large: "h-24"
  };

  return (
    <img
      src={logo}
      alt="KRZz Auto"
      className={`${sizes[size] || sizes.default} w-auto object-contain ${className}`}
    />
  );
};

export default KrzzLogo;